import {
  ROUTE_NNC_DETAIL_REPORT,
} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';

const NNCDetailReport = lazy(() =>
  import('../../../screens/NNCDetailReport')
    .then(module => ({default: module.NNCDetailReport})));

const NNCDetailReportNavigation = [{
  path: ROUTE_NNC_DETAIL_REPORT,
  loader: authLoader,
  element: (
    <Suspense fallback={<Spin />}>
      <NNCDetailReport />
    </Suspense>
  ),
},
];

export default NNCDetailReportNavigation;
